export default __webpack_public_path__ + "static/media/payment-options-bambora.211f2ec6.png";